import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import jwtUtil from '@/utils/jwtUtil'
Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: () => import('@/routes/HomeRoute')
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('@/routes/LoginRoute')
    },
    {
        path: '/users',
        name: 'Users',
        component: () => import('@/routes/UserRoute')
    },
    {
        path: '/articles',
        name: 'Articles',
        component: () => import('@/routes/ArticleRoute')
    },
    {
        path: '/articles/:articleId/:mode',
        name: 'Article Form',
        component: () => import('@/forms/ArticleForm')
    },
    {
        path: '/users/:userId/:mode',
        name: 'User Form',
        component: () => import('@/forms/UserForm')
    },
    {
        path: '/articles/:mode',
        name: 'Create Article Form',
        component: () => import('@/forms/ArticleForm')
    },
    {
        path: '/users/:mode',
        name: 'Create User Form',
        component: () => import('@/forms/UserForm')
    },
    {
        path: '/pages',
        name: 'Pages',
        component: () => import('@/routes/PageRoute')
    },
    {
        path: '/pages/:pageId/:mode',
        name: 'Page Form',
        component: () => import('@/forms/PageForm')
    },
    {
        path: '/pages/:mode',
        name: 'Create Page Form',
        component: () => import('@/forms/PageForm')
    },
    {
        path: '/page',
        redirect: '/pages'
    },
    {
        path: '/players',
        name: 'Players',
        component: () => import('@/routes/PlayerRoute')
    },
    {
        path: '/players/:playerId/:mode',
        name: 'Player Form',
        component: () => import('@/forms/PlayerForm')
    },
    {
        path: '/players/:mode',
        name: 'Create Player Form',
        component: () => import('@/forms/PlayerForm')
    },
    {
        path: '/courts',
        name: 'Courts',
        component: () => import('@/routes/CourtRoute')
    },
    {
        path: '/courts/:courtId/:mode',
        name: 'Court Form',
        component: () => import('@/forms/CourtForm')
    },
    {
        path: '/courts/:mode',
        name: 'Create Court Form',
        component: () => import('@/forms/CourtForm')
    },
    {
        path: '/sponsors',
        name: 'Sponsors',
        component: () => import('@/routes/SponsorRoute')
    },
    {
        path: '/sponsors/:sponsorId/:mode',
        name: 'Sponsor Form',
        component: () => import('@/forms/SponsorForm')
    },
    {
        path: '/sponsors/:mode',
        name: 'Create Sponsor Form',
        component: () => import('@/forms/SponsorForm')
    },
    {
        path: '/sports',
        name: 'Sports',
        component: () => import('@/routes/SportRoute')
    },
    {
        path: '/sports/:sportId/:mode',
        name: 'Sport Form',
        component: () => import('@/forms/SportForm')
    },
    {
        path: '/sports/:mode',
        name: 'Create Sport Form',
        component: () => import('@/forms/SportForm')
    },
]

const router = new VueRouter({
    mode: 'history',
    routes
})

router.beforeEach((to, from, next) => {
    const currentUser = store.getters.currentUser
    const token = store.getters.getToken
    if ((!token || (token && jwtUtil.isJwtExpired(token))) && to.name !== 'Login') {
        store.dispatch('logout').then(() => next({ path: '/login' }))
    } else if (!currentUser && to.name === 'Login') {
        next()
    } else if (currentUser.role === 'admin' || (to.meta.roles && to.meta.roles.includes(currentUser.role))) {
        next()
    }
})

export default router
